<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="資金決済法に基づく表記" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">運営会社名称</span>
            <span class="text">株式会社はっち</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表責任者</span>
            <span class="text">八塚 健</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">会社登記住所・営業所住所</span>
            <span class="text">〒547-0011</span>
            <span class="text">大阪府大阪市平野区長吉出戸七丁目3-39</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Coin(本サイト内通貨)所有上限・期限</span>
            <span class="text">Coinの上限はございません。</span>
            <span class="text">ただし、Coin購入及びCoin交換からCoinを使用することなく最終のご使用日から6ヶ月(当日を含む)が経過した場合、あらかじめお客様に通知することなくアカウントを削除することができます。</span>
            <span class="text">この場合、Coinは失効いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Coin使用場所の範囲</span>
            <span class="text">Coinの上限はございません。</span>
            <span class="text">Coin(本サイト内通貨)は、ご登録されているアカウント内にてご利用可能となります。</span>
            <span class="text">また、アカウントの譲渡及びCoinの譲渡は禁止いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">ご利用上のご注意</span>
            <span class="text">Coin(本サイト内通貨)の払い戻しは致しかねます。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">所有Coinの確認方法</span>
            <span class="text">本サイトの画面上にてご確認いただけます。</span>
            <span class="text">所有Coinに動きがございましたら、そこの数字が自動で変化いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">お問い合わせ先</span>
            <span class="text">こちらからお問い合わせください。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">利用規約</span>
            <span class="text">本サイトの利用規約をご確認ください。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
